import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { getBannerConfig } from "../../global/bannerType";
import { useEffect, useState } from "react";
import { isAuthenticatedSelector } from "../../modules/auth/selectors";
import { useDispatch, useSelector } from "react-redux";
import { avvisiUtenteSelector } from "../../modules/profilazione/selectors";
import { getAvvisiUtenteAction } from "../../modules/profilazione/actions";

export const AvvisoHome = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const avvisiUtente = useSelector(avvisiUtenteSelector);

    const [closedBannerArray, setClosedBannerArray] = useState(
        JSON.parse(localStorage.getItem("avvisiPrenPrev")) !== null
            ? JSON.parse(localStorage.getItem("avvisiPrenPrev"))?.closedBannerList
            : []);

    const onClickAvviso = (id) => {
        const newClosedBannerArray = [...closedBannerArray, id];
        // aggiorno lo useState per non mostrare i banner chiusi
        setClosedBannerArray(newClosedBannerArray);
        // aggiorno il localStorage per memorizzare i banner chiusi
        const bannerObject = {
            userState: isAuthenticated,
            closedBannerList: newClosedBannerArray
        };
        localStorage.setItem("avvisiPrenPrev", JSON.stringify(bannerObject));
    }

    useEffect(() => {
        // se cambia lo stato dell'utente (login/logout), occorre mostrare nuovamente tutti i banner
        if (JSON.parse(localStorage.getItem("avvisiPrenPrev"))?.userState !== isAuthenticated) {
            setClosedBannerArray([])
            localStorage.removeItem("avvisiPrenPrev");
        }
    }, [isAuthenticated]);


    useEffect(() => {
        dispatch(getAvvisiUtenteAction());
    }, []);

    return (
        <>

            <Box sx={{
                flexGrow: 1,
                overflow: 'hidden',
                px: 4,
                width: "100%",
            }}>
                <Grid container direction="row" >
                    {
                        avvisiUtente?.value?.map((item, index) => {
                            if (!closedBannerArray?.includes(item?.idBanner))
                                return (
                                    <Grid item key={index} xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Banner item={item} onClick={onClickAvviso} />
                                    </Grid>
                                )
                            else
                                return null

                        })
                    }
                </Grid>
            </Box>

        </>

    );
}

const Banner = ({ item, onClick }) => {
    const { icon, color, backgroundColor } = getBannerConfig(item?.bannerType);
    return (
        <Paper
            elevation={2}
            sx={{
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                width: "100%",
                mb: { xs: '10px', sm: '10px', md: '10px', lg: '10px', xl: '10px' },
                backgroundColor: backgroundColor
            }}
        >
            <Box sx={{ margin: { xs: '5px', sm: '5px', md: '10px', lg: '10px', xl: '15px' }, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                <Box
                    sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", height: "100%" }}
                >
                    <Typography sx={{
                        textTransform: 'none', fontWeight: 'bold', wordBreak: "break-word",
                        fontSize: { xs: 'medium', sm: 'medium', md: 'x-medium', lg: 'x-medium', xl: 'x-medium' },
                    }}
                    >
                        <FontAwesomeIcon icon={icon} style={{ color: color, paddingRight: '5px' }} role="presentation" />
                        {item?.title}
                    </Typography>
                    {item?.dismissible &&
                        <IconButton
                            className='cursorPointer'
                            id={'close-banner-id-' + item?.idBanner}
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                '&:focus': {
                                    backgroundColor: '#E8E9ED',
                                },
                            }}
                            size="small"
                            aria-label="close"
                            color="inherit"
                            title={"Chiudi avviso"}
                            onClick={() => { onClick(item?.idBanner) }}
                        >
                            <FontAwesomeIcon icon={faClose} size='1x' color={'#1D294B'} aria-label='Chiudi avviso' id={'close-banner-icon-id-' + item?.idBanner} />
                        </IconButton>
                    }
                </Box>


                <Typography component="span" sx={{
                    textTransform: 'none', wordBreak: "break-word",
                    fontSize: { xs: 'small', sm: 'medium', md: 'x-medium', lg: 'x-medium', xl: 'x-medium' },
                }}
                >
                    <Box>{item?.message}</Box>
                </Typography>
            </Box>
        </Paper >
    );
}